import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MaterialModule } from "../../material/material.module";

// a message shown beside part of the screen. In a screen tour it also shows the step and buttons to move through the tour
@Component({
    selector: 'app-help-overlay',
    templateUrl: './help-overlay.html',
    styleUrls: ['./help-overlay.scss'],
    imports: [MaterialModule],
    standalone: true
})
export class HelpOverlayComponent {
    @Input() message:string
    @Input() step = 0           // 1 based; 0 when the message isn't part of a tour
    @Input() count = 0

    @Output() next = new EventEmitter<void>()
    @Output() back = new EventEmitter<void>()
    @Output() end = new EventEmitter<void>()

    get inTour() {
        return this.count > 0
    }
}
